import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import { sortOpts } from '../../utils/utils'
import Form from '../ui/Form'

class SetsAddCompForm extends Form {

  constructor(props){
    super(props);
    this.state = {
      data: props.data,
      errors: {}
    };
  }

  saveComp = e => {
    e.preventDefault();
    const { data } = this.state;
    this.props.addSets('comp', data, (err, id) => {
      if (err) {
        this.setState({errors: err});
        return;
      }
      this.props.onCancel();
      if (this.props.afterSave) {
        this.props.afterSave(id);
      }
    });
  }

  updateSrvgs = e => {
    this.setState({
      data:{
        ...this.state.data,
        comp_srvg_ids: e
      }
    });
  }

  updateCtype = e => {
    this.setState({
      data:{
        ...this.state.data,
        comp_ctype_id: e ? e.value : 0
      }
    });
  }

  render(){
    const { srvgs, onCancel, ctypes } = this.props;
    const { data, errors } = this.state;

    const srvgIdArray = data.comp_srvg_ids.split(',');
    srvgs[''] = '';
    const srvgsOpt = [];
    for (let key in srvgs){
      if(srvgs.hasOwnProperty(key) && (srvgs[key].srvg_active === 1
        || srvgIdArray[key])) {
        srvgsOpt.push({value:key,label:srvgs[key].srvg_desc});
      }
    }
    srvgsOpt.sort(sortOpts);

    var ctypesOpt = [];
    for (let key in ctypes){
      if(ctypes.hasOwnProperty(key) && (ctypes[key].ctype_active === 1
        || ctypes[key].ctype_id === data.comp_ctype_id)) {
        ctypesOpt.push({value:key,label:ctypes[key].ctype_desc});
      }
    }
    ctypesOpt.sort(sortOpts);

    return (
      <div
        className="modal"
        style={{
          paddingTop:'15%',
          overflowY:'visible',
          backgroundColor: 'rgba(30,30,30,.7)',
          display:'block'
        }}
      >
        <div
          className="modal-admin modal-m"
          style={{margin: 'auto', maxWidth: '90%'}}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 style={{margin:0}}>Создание контрагента</h4>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-xs-2">
                  <div className="form-group">
                    <input type="text"
                      className="form-control"
                      value={data.comp_desc}
                      name="comp_desc"
                      onChange={this.updateInput}
                      placeholder="Краткое название"
                      autoFocus
                    />
                  </div>
                  <div className="form-group">
                    <Select
                      options={ctypesOpt}
                      value={data.comp_ctype_id}
                      onChange={this.updateCtype}
                      placeholder="Тип"
                    />
                  </div>
                </div>
                <div className="col-xs-2">
                  <div className="form-group">
                    <Select
                      clearable={false}
                      options={srvgsOpt}
                      value={data.comp_srvg_ids}
                      onChange={this.updateSrvgs}
                      placeholder="Группы услуг"
                      simpleValue
                      multi
                    />
                  </div>
                </div>
                <div className="col-xs-3">
                  <textarea type="text"
                    rows="2"
                    className="form-control"
                    value={data.comp_note}
                    onChange={this.updateInput}
                    name="comp_note"
                    placeholder="Описание"
                  />
                  <label>
                    Клиент{" "}
                    <input type="checkbox" checked={data.comp_order}
                      name="comp_order"  onChange={this.handleChBox} />
                  </label><br />
                  <label>
                    Подрядчик{" "}
                    <input type="checkbox" checked={data.comp_cost}
                      name="comp_cost" onChange={this.handleChBox} />
                  </label><br />
                  <label>
                    Издержки{" "}
                    <input type="checkbox" checked={data.comp_expense}
                      name="comp_expense" onChange={this.handleChBox} />
                  </label><br />
                  <label>
                    Сотрудник{" "}
                    <input type="checkbox" checked={data.comp_empl}
                      name="comp_empl" onChange={this.handleChBox} />
                  </label>
                </div>
                <div className="col-xs-2">
                  <textarea type="text"
                    rows="4"
                    className="form-control"
                    value={data.comp_addr}
                    name="comp_addr"
                    onChange={this.updateInput}
                    placeholder="Адрес компании"
                  />
                </div>
                <div className="col-xs-3">
                  <input type="text"
                    className="form-control"
                    value={data.comp_tel}
                    onChange={this.updateInput}
                    name="comp_tel"
                    placeholder="Телефон"
                  />
                  <input type="text"
                    className="form-control"
                    value={data.comp_email}
                    onChange={this.updateInput}
                    name="comp_email"
                    placeholder="Email"
                  />
                  <input type="text"
                    className="form-control"
                    value={data.comp_long}
                    name="comp_long"
                    onChange={this.updateInput}
                    placeholder="Название для печатных форм"
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn btn-default"
                onClick={onCancel}
              >Отмена</button>{" "}
              <button
                type="button"
                className="btn btn-success"
                onClick={this.saveComp}
              >Сохранить</button>
              {errors.form && <div className="alert alert-danger">{errors.form}</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SetsAddCompForm.propTypes = {
  afterSave: PropTypes.func,
  addSets: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  srvgs: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired
}

export default SetsAddCompForm;



// WEBPACK FOOTER //
// ./src/components/settings/SetsAddCompForm.js